import { NAMES_ROUTES } from "@/const/routes.constants"
import { getIssuesCountMapOrderedSeverity } from "@/domain/vulnerability"
import {
  DEFAULT_LONG_FORMAT,
  getDateInUserLocale,
  getTimestampInMillisecondsFromSecond
} from "@/helpers/date.helpers"
import { getLastDetectedCellData } from "@/helpers/table.helpers"

import type { VMResponse } from "@/api/useInventory.types"

export const getVirtualMachineTabData = (response: VMResponse) => {
  const { data = [], metadata } = response || {}
  const { TRIAGE } = NAMES_ROUTES
  const { ROOT, ISSUES } = TRIAGE

  return {
    data: data.map((record, index) => {
      const { id, data: entity } = record || {}
      const { autoScalingGroups, lastSeen, ...item } = entity
      const { correlatedProjects = [] } = item

      return {
        id,
        key: id,
        autoScalingGroups: {
          id: `autoScalingGroups_${id}_${index}`,
          items: autoScalingGroups,
          label: autoScalingGroups[0] || "",
          count: autoScalingGroups.length - 1
        },
        lastSeen: getDateInUserLocale(
          getTimestampInMillisecondsFromSecond(lastSeen),
          DEFAULT_LONG_FORMAT
        ),
        severity: getIssuesCountMapOrderedSeverity(item.issuesSummary as any),
        relatedProjects: {
          id: `relatedProjects-${index}`,
          count: correlatedProjects.length - 1,
          label: correlatedProjects[0]?.name || "",
          items: correlatedProjects.map((project) => ({
            externalLink: `/${ROOT}/${ISSUES}?${new URLSearchParams({
              issueStatus: "open",
              projectName: project.name
            }).toString()}`,
            ...project
          })),
          copyable: true,
          width: "100%"
        },
        ...item,
        ...getLastDetectedCellData(record)
      }
    }),
    metadata
  }
}
